var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fraud-provider',{attrs:{"object":function () { return ({ brand_id: _vm.brandId }); },"type":"brand"}},[_c('fraud-events-table',{attrs:{"id":"FET1","show-client":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }